import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { OfferOverviewPage } from '../offer/OfferOverview/OfferOverviewPage';

const offersSearchSchema = z.object({
    searchQuery: z.string().optional(),
    customerIds: z.array(z.string()).optional(),
    supplierIds: z.array(z.string()).optional(),
    page: fallback(z.number(), 0).default(0),
    tab: fallback(z.string(), 'enquired').default('enquired'),
    sortValue: fallback(
        z.object({
            sortField: z.string(),
            sortDirection: z.string(),
        }),
        {
            sortField: 'dateUpdated',
            sortDirection: 'DESC',
        }
    ).default({
        sortField: 'dateUpdated',
        sortDirection: 'DESC',
    }),
});

export const Route = createFileRoute('/_app/offers')({
    component: OfferOverviewPage,
    validateSearch: zodSearchValidator(offersSearchSchema),
});
